import { Component, ErrorHandler, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Project } from 'src/app/open-age/gateway/models/project.model';
import { Release } from 'src/app/open-age/gateway/models/release.model';

import { PagerBaseComponent } from '~/app/open-age/core/structures';

import { ReleaseService } from 'src/app/open-age/gateway/services/release.service';

export class ReleaseListBaseComponent extends PagerBaseComponent<Release> implements OnInit, OnChanges {

  @Input()
  project: Project;

  @Input()
  selectedStatus: string;

  @Input()
  ongoing: boolean;

  @Input()
  isClosed: boolean;

  @Input()
  isOngoing: boolean;

  selectedSubject: string;

  constructor(
    api: ReleaseService,
    errorHandler: ErrorHandler
  ) {
    super({
      api,
      errorHandler,
      filters: ['projectId', 'status', 'subject', 'isClosed', 'isOngoing']
    });

    api.afterCreate.subscribe((newRelease) => {

      if (newRelease.project.id !== this.project.id) {
        return;
      }

      // if (this.selectedStatus && newRelease.status.type.code.toLowerCase() !== this.selectedStatus.toLowerCase()) {
      //   return;
      // }

      const items: Release[] = [];

      items.push(newRelease);
      items.push(...this.items);
      this.items = items;
    });
  }

  ngOnInit() {
    this.refresh();
  }

  ngOnChanges() {
    this.refresh();
  }

  refresh() {
    if (this.project) {
      this.filters.properties['projectId'].value = this.project.id;
    }

    if (this.selectedStatus) {
      this.filters.properties['status'].value = this.selectedStatus;
    }

    if (this.selectedSubject) {
      this.filters.properties['subject'].value = this.selectedSubject;
    }

    if (this.isClosed !== undefined) {
      this.filters.properties['isClosed'].value = this.isClosed;
    }

    if (this.isOngoing !== undefined) {
      this.filters.properties['isOngoing'].value = this.isOngoing;
    }

    this.fetch();
  }
}
